import { render } from "./AppAvatarImg.vue?vue&type=template&id=70718d96&scoped=true"
import script from "./AppAvatarImg.vue?vue&type=script&lang=js"
export * from "./AppAvatarImg.vue?vue&type=script&lang=js"

import "./AppAvatarImg.vue?vue&type=style&index=0&id=70718d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70718d96"]])

export default __exports__